<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div class="popup_top" style="height: 77px;">
        <div class="popup-title">다시보기</div>
      </div>
      <div class="video-wrap" style="padding: 35px;">
        <video controls :src="videoSrc" playsinline></video>
      </div>
      <div class="btnArea">
        <button class="invite-btn" @click="close">닫기</button>
      </div>
    </v-card>
    <!-- <edit-meeting-dialog
      :dialog="editMeetingDialog.dialog"
      :meetingInfo="editMeetingDialog.meeting"
      @editedMeeting="editedMeeting"
    /> -->
    <!-- <all-attendee-dialog
      :dialog="allAttendeeDialog.dialog"
      :attendees="allAttendeeDialog.attendees"
      :closeDialog="closeAllAttendees"
    /> -->
  </v-dialog>
</template>
<script>
import Util from "@/util";
import moment from "moment";
import BaseModal from "@/components/popup/BaseModal";
// import EditMeetingDialog from "@/components/popup/EditMeetingDialog";
export default {
  components: {
    BaseModal: BaseModal,
    // EditMeetingDialog,
  },
  watch: {
    dialog: {
      async handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },
  props: ["dialog", "meetingInfo", "closeDialog"],
  data() {
    return {
      videoSrc: "",
    };
  },
  methods: {
    async init() {
      let params = { meetingKey: this.meetingInfo.meetingKey };
      await this.$http
        .get("/api/v1/meetings/streamVideo", { params: params })
        .then(response => {
          this.videoSrc = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    close() {
      this.videoSrc = "";
      this.closeDialog();
    },
  },
};
</script>
<style scoped>
.popup_top {
  padding-left: 0;
  background-color: #efeefd;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.popup-title {
  line-height: 77px;
  color: #604af3;
  font-weight: 700;
  font-size: 24px;
  padding-left: 24px;
}
.dataTable table td:nth-child(odd) {
  background: #fff;
  width: 145px;
  padding-left: 40px;
}

.dataTable table.info td:nth-child(odd) {
  background: #fff;
  padding-left: 0px;
}

.dataTable table.detail td:nth-child(2n) {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  color: #333;
  vertical-align: top;
}

.dataTable table td {
  height: 66px;
  background: #fff;
  letter-spacing: -2px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #333;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
}

.v-dialog {
  max-height: none !important;
}

.btnArea {
  display: flex;
  justify-content: center;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/VideoDialog.vue